import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

const Admins = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [admins, setAdmins] = useState([]);
    const [allAdmins, setAllAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)
    const [sortOrder, setSortOrder] = useState('asc')
    const [adminsPending, setAdminsPending] = useState(false)
    const [totalAdmins, setTotalAdmins] = useState(0)
    // const [makingAmbassador, setMakingAmbassador] = useState(false)
    const [showAmbassadors, setShowAmbassadors] = useState(false);
    const [statusPending, setStatusPending] = useState(false);

    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationSubject, setNotificationSubject] = useState("");
    const [notificationSending, setNotificationSending] = useState(false);
    const [ambassadorDuration, setAmbassadorDuration] = useState("");
    const [ambassadorAmount, setAmbassadorAmount] = useState("");
    const [searchString, setSearchString] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const sortedAdmins = sortOrder === 'asc' ? [...admins] : [...admins].reverse();
    // console.log(totalAdmins);
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedAdmins.slice(indexOfFirstItem, indexOfLastItem);

    // Create an instance of Axios
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const viewAdmin = (index) => {
        // const clickedObject = products[index];
        setSelectedAdmin(admins[index])
        console.log("index clicked:" + index)
        console.log(selectedAdmin)
    }
    const handleNotificationContentChange = (event) => {
        setNotificationMessage(event.target.value);
    };

    const handleSubmitNotification = (event) => {
        event.preventDefault();
        if (notificationMessage.trim() === "") {
            // Handle empty content case
            return;
        }
        setNotificationSending(true);
        api
            .post(`${base_url}/notification/add/${selectedAdmin.userID}`, {
                subject: notificationSubject,
                message: notificationMessage,
            })
            .then((response) => {
                // Handle successful response, e.g., show a succes  s message
            })
            .catch((error) => {
                // Handle error, e.g., show an error message
                addNotificationError("An error occurred and your notification wasnt added.")
            })
            .finally(() => {
                setNotificationSending(false);
                setNotificationMessage("");
                addNotificationSuccess("Notification was successsfully created")
            });
    };

    const fetchData = async () => {
        try {
            setAdminsPending(true)
            const response = await api.get(`${base_url}/user/get-all-admins`);
            setAdmins(response.data.result);
            setAdminsPending(false)
            console.log(admins)
        } catch (error) {
            console.log(error);
            // deleteAdminError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    const successAlert = (msg) => toast.success(msg, {
        position: "top-center",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
    const errorAlert = (msg) => toast.success(msg, {
        position: "top-center",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });


    const descFetchData = async () => {
        try {
            setAdminsPending(true)
            const response = await api.get(`${base_url}/user/user-by-page/10/${currentPage}`);
            setAdmins(response.data.jointObject);
            setAdminsPending(false)
            // console.log(admins)
        } catch (error) {
            console.log(error);
            // deleteAdminError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

      // DEACTIVATE ACCOUNT


    const deactivate = (email) => {
        setStatusPending(true)
        api.post(`${base_url}/auth/deactivate-account/`, {
            "email": email
        })
            .then(function (response) {
                console.log(response.data)
                fetchData()
                setStatusPending(false)

                successAlert("Account successfully De-Activated")


            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                    errorAlert(error.response)

                } else {
                    console.log("An error occurred")
                    errorAlert("An error occurred")

                }
                setStatusPending(false)
            })
    }

    const activate = (email) => {
        setStatusPending(true)
        api.post(`${base_url}/auth/activate-account/`, {
            "email": email
        })
            .then(function (response) {
                console.log(response.data)
                fetchData()
                setStatusPending(false)
                successAlert("Account successfully activated")


            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                    errorAlert(error.response)

                } else {
                    console.log("An error occurred")
                    errorAlert("Account successfully activated")

                }
                setStatusPending(false)
            })
    }

    const makeAdminAnAmbassador = async (email) => {
        try {
            

            api
            .post(`${base_url}/notification/add/${selectedAdmin.userID}`, {
                email: email,
                subject: ambassadorDuration,
                message: ambassadorAmount,
            })
            .then((response) => {
                // Handle successful response, e.g., show a succes  s message
                
                console.log("Admin has been successfully made an ambassador")
            })
            .catch((error) => {
                // Handle error, e.g., show an error message
                addNotificationError("An error occurred and your request was not successful.")
            });
            

            
            // console.log(admins)
        } catch (error) {
            console.log(error);
            // deleteAdminError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    // const fetchAllAdmins = async () => {
    //     try {
    //         const response = await api.get(`${base_url}/user/all-users`);
    //         setAllAdmins(response.data.users);
    //         console.log(allAdmins)
    //     } catch (error) {
    //         console.log(error);
    //         // deleteAdminError("An error occured while trying to delete entry. Try again or contact support")
    //     }
    // };

    useEffect(() => {
        fetchData();
        // fetchAllAdmins();

        //check total admins
        api.get(`${base_url}/user/total-users/all`)
            .then(function (response) {
                // console.log(response.data)
                setTotalAdmins(response.data.users)
            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                } else {
                    console.log("An error occurred")
                }
            })
    }, [currentPage]);

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const toggleShowAmbassadors = () => {
        setShowAmbassadors(!showAmbassadors); 
    };

    const addNotificationSuccess = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
    const addNotificationError = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(totalAdmins / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(totalAdmins / itemsPerPage));
    };

    // const pageButtons = () => {
    //     const totalPages = Math.ceil(totalAdmins / itemsPerPage);
    //     const buttons = [];

    //     // Display up to 3 page numbers ahead of the current page
    //     for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
    //         buttons.push(
    //             <button
    //                 key={i}
    //                 className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
    //                 onClick={() => setCurrentPage(i)}
    //             >
    //                 {i}
    //             </button>
    //         );
    //     }

    //     return buttons;
    // };

    const handleSearchInputChange = async (event) => {
        const searchString = event.target.value;
        setSearchString(searchString);
        if (searchString.trim() === "") {
            setSearchResults([]);
            return;
        }
        try {
            const response = await api.get(`${base_url}/user/search/${searchString}`);
            setSearchResults(response.data.searchResults);
        } catch (error) {
            console.log(error);
        }
    };


    // end navigation options
    return (
        <>
            <div>
                {/* <ToastContainer /> */}
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi bi-person"></i> ALL ADMINS 
                            {/* <small className="text-secondary" style={{ fontWeight: "400", fontSize: "smaller" }}>({totalAdmins})</small> */}
                        </h6>
                    </div>
                    
                    <div className="d-flex justify-content-end align-items-center flex-fill text-end">

                    <div className="input-group ms-1" style={{ width: '250px' }}>
        {/* <input
            type="text"
            className="form-control custom-input-group"
            placeholder="Search admins..."
            value={searchString}
            onChange={handleSearchInputChange}
        /> */}
    </div>


                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Manage</th>
                            </tr>
                        </thead>
                        {/* <tbody>
                            {
                                adminsPending ? (
                                    <tr>
                                        <td colSpan="5" className="text-center my-">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    admins.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.fullName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.phonenumber}</td>
                                            <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>Nil</td>
                                            <td>
                                                <button className="btn-custom-sm" data-bs-toggle="modal" data-bs-target="#view-admin" onClick={() => viewAdmin(index)}>
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )
                            }
                        </tbody> */}
                        <tbody>
    {adminsPending ? (
        <tr>
            <td colSpan="5" className="text-center my-">
                <div className="spinner-border spinner-border-lg text-custom my-3"></div>
            </td>
        </tr>
    ) : (
        (searchResults.length > 0 ? searchResults : sortedAdmins).map((item, index) => {
            // Check if the admin is an ambassador and the filter is active
            if (showAmbassadors && !item.isAmbassador) {
                return null; // Skip rendering this row
            }
            return (
                <tr key={index}>
                    <td>{item.email}</td>
                    <td>{item.isActive === false ? (
                                                <span className='text-danger bold'>Not Active <i className='bi-exclamation-circle'></i></span>
                                            ) : (
                                                <span className='text-success bold'>Active <i className='bi-check-circle'></i></span>
                                            )}
                                            </td>
                    <td>
                                                {
                                                    item.isActive === false ? (
                                                        <div>
                                                            {
                                                                statusPending ? (
                                                                    <button className="btn-success-sm btn-sm mb-1 disabled-btn" style={{ width: "130px" }}>Activate</button>
                                                                ) : (
                                                                    <button className="btn-success-sm btn-sm mb-1" style={{ width: "110px" }} onClick={() => activate(item.email)}>Activate</button>
                                                                )
                                                            }

                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {
                                                                statusPending ? (
                                                                    <button className="btn-danger-sm btn-sm mb-1 disabled-btn" style={{ width: "130px" }}>Deactivate</button>

                                                                ) : (
                                                                    <button className="btn-danger-sm" style={{ width: "110px" }} onClick={() => deactivate(item.email)}>Deactivate</button>

                                                                )
                                                            }

                                                        </div>
                                                    )
                                                }
                                            </td>
                </tr>
            );
        })
    )}
</tbody>
                    </table>
                </div>

                {/* <div className="pagination btn-group">
                {searchResults.length === 0 && totalAdmins > itemsPerPage && (
                        <>
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button> */}

                    {/* page numbered buttons */}
                    {/* {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(totalAdmins / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(totalAdmins / itemsPerPage)}
                    >
                        Last
                    </button>
                    </>
                    )}
                </div> */}

            </div>

            {/* Modal data content */}
            <div className="modal fade" id="view-admin">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-person"></i> Admin Information</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="col-12">
                                    <h4 className="text-custom">{selectedAdmin.fullName}</h4>
                                    <dl>
                                        <dt></dt>
                                        <dd></dd>
                                    </dl>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt>Admin ID</dt>
                                            <dd>{selectedAdmin.userID}</dd>

                                            <dt>Corper Invest ID</dt>
                                            <dd>{selectedAdmin.corperInvestID}</dd>

                                            <dt>Email</dt>
                                            <dd>{selectedAdmin.email}</dd>

                                            <dt>Phone Number</dt>
                                            <dd>{selectedAdmin.phonenumber}</dd>

                                            <dt>Account Type</dt>
                                            <dd>{selectedAdmin.corperInvestType}</dd>

                                            <dt>BVN</dt>
                                            <dd>{selectedAdmin.BVN}</dd>

                                            <dt>Creation Date</dt>
                                            <dd>{moment(selectedAdmin.createdAt).format('DD MMM YYYY h:mm:ss a')}</dd>
                                        </dl>
                                    </div>
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt>Registeration status</dt>
                                            <dd>{selectedAdmin.isRegistrationCompleted ? (<>Completed</>) : (<>Not Completed</>)}</dd>

                                            <dt>Documents status</dt>
                                            <dd>{selectedAdmin.isUploadDocCompleted ? (<>Uploaded</>) : (<>Not Uploaded</>)}</dd>

                                        </dl>
                                        <form onSubmit={makeAdminAnAmbassador(selectedAdmin.email)}>
                                            <div className="mb-3">
                                                <label htmlFor="notificationContent" className="form-label bold">Make Admin An Ambassador</label>
                                                <div className="input-group my-1">
                                                    <input type="text" className="form-control custom-input-group" value={ambassadorDuration} onChange={(e) => setAmbassadorDuration(e.target.value)} placeholder="Duration" required />
                                                </div>
                                                <div className="input-group my-1">
                                                    <input type="text" className="form-control custom-input-group" value={ambassadorAmount} onChange={(e) => setAmbassadorAmount(e.target.value)} placeholder="Amount" required />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn-custom" disabled={ambassadorAmount}>
                                                 Make Admin An Ambassador
                                            </button>
                                        </form>
                                        <form onSubmit={handleSubmitNotification}>
                                            <div className="mb-3">
                                                <label htmlFor="notificationContent" className="form-label bold">Notification</label>
                                                <div className="input-group my-1">
                                                    <span class="input-group-text input-group-text-custom"><i class="bi-info-circle"></i></span>
                                                    <input type="text" className="form-control custom-input-group" value={notificationSubject} onChange={(e) => setNotificationSubject(e.target.value)} placeholder="Subject" required />
                                                </div>
                                                <textarea
                                                    id="notificationContent"
                                                    className="form-control  custom-input-group"
                                                    rows="3"
                                                    value={notificationMessage}
                                                    onChange={handleNotificationContentChange}
                                                    placeholder="Content"
                                                />
                                            </div>
                                            <button type="submit" className="btn-custom" disabled={notificationSending}>
                                                {notificationSending ? "Sending..." : "Send Notification"}
                                            </button>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* <!-- Modal footer --> */}
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
            {/* End modal data content */}
        </>
    );
};

export default Admins;

